import { connect } from "react-redux";
import dispatchers from "ui/molecule/resetPassword/dispatchers";
import selectors from "ui/molecule/resetPassword/selectors";
import ResetPasswordUI from "ui/molecule/resetPassword/ResetPasswordUI";

// alebo takto temu mame v props export default withStyles(customStyles, { withTheme: true })(AddBabySitterUI);
export default connect(selectors, dispatchers)(ResetPasswordUI);
